import { LaunchArguments } from "@-/com.npmjs.react-native-launch-arguments";
import onetime from "@-/com.npmjs.onetime";

/**
 * Whether this launch asked to skip the new-learner onboarding (`hanSkipOnboarding`), so "Get
 * Started" and Sign Up enter the app as they did before it: the welcome galaxy's card dive, the
 * whole strip, and both corner menus.
 *
 * Only E2E runs pass it. Maestro's guest flows exercise Learn, Browse, Settings and the decks, and the
 * onboarding hands those out one at a time (in the strip and the drawer alike, Search only after the
 * first level), so without it every guest flow would have to finish a level first.
 * A flow that covers the onboarding itself launches without the argument. Maestro passes it through
 * `launchApp: arguments:`, and `reset-app.sh` as an intent extra on Android's release cold launch.
 *
 * Reading launch arguments throws where the native module is absent (web, vitest), so this is
 * defensive, and memoized because the value cannot change after launch.
 */
export const isOnboardingSkippedByLaunchArgument = onetime((): boolean => {
  try {
    const { hanSkipOnboarding } = LaunchArguments.value<{ hanSkipOnboarding?: unknown }>();
    return hanSkipOnboarding === true || hanSkipOnboarding === "true";
  } catch {
    return false;
  }
});
